class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
    this.parent = this.closest(".product-recommendations--parent");
    this.productContainer = this.querySelector('.cart-drawer--recommendations--products');
    this.hasLoaded = false;
  }

  fetchProducts() {   
    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((text) => {
        const parser = new DOMParser();
        const parsedDoc = parser.parseFromString(text, "text/html");
        const recommendations = parsedDoc.querySelector("cart-product-recommendations");

        if (recommendations) {
          this.innerHTML = recommendations.innerHTML;
          theme.reinitProductGridItem(this.productContainer);
        }
        document.dispatchEvent(new CustomEvent('cart:recommendation:loaded', { detail: this }));
      })
      .catch((e) => {
        console.error(e);
      });
  }
  connectedCallback() {
    if (!this.hasLoaded) {
      this.hasLoaded = true;
      this.fetchProducts();
    }
  }
}
  
customElements.define("cart-product-recommendations", ProductRecommendations);

function showToolbar() {
  let toolbars = document.querySelectorAll(".menu--toolbar");
  if (!toolbars.length && window.innerHeight <= 700) return;

  toolbars.forEach((toolbar) => toolbar.classList.remove("hide"));
}

function switchImages() {
  let container = document.querySelector(".productImageSwitcher");
  if (!container) return;

  let btns = container.querySelectorAll("button");

  btns.forEach((btn) => {
    btn.addEventListener("click", function () {
      btns.forEach((b) => b.classList.remove("selected"));
      this.classList.add("selected");

      let scroll_grids = document.querySelectorAll("[scroll-grid]");

      if (this.classList.contains("model")) {
        initScrollProgress("modelImage");
      } else if (this.classList.contains("product")) {
        initScrollProgress("productImage");
      }
    });
  });
}

function setupCollectionForm() {
  const forms = document.body.querySelectorAll(".collection--product__form");
  if (forms.length) forms.forEach((form) => new theme.AjaxProduct(form));
}

function calculateScrollProgress(
  container,
  progressBar,
  images,
  start = 0,
  scrollToClass = null
) {
  if (!container || !progressBar || !images.length) return;

  if (typeof scrollToClass === "string") {
    const targetImage = container.querySelector(`.${scrollToClass}`);
    if (targetImage) {
      container.scrollLeft = targetImage.offsetLeft;
      return;
    }
  }

  progressBar.style.transform = `scaleX(${start})`;

  container.addEventListener("scroll", () => {
    const totalImageWidth = Array.from(images).reduce(
      (acc, image) => acc + image.clientWidth,
      0
    );
    const scrollPosition = container.scrollLeft;
    const totalScrollWidth = totalImageWidth - container.clientWidth;

    if (totalScrollWidth <= 0) {
      console.warn(
        "Total scroll width is zero or negative. Exiting scroll calculation."
      );
      return;
    }

    const scrollPercentage =
      start + (scrollPosition / totalScrollWidth) * (1 - start);
    const cappedScrollPercentage = Math.min(scrollPercentage, 1);

    progressBar.style.transform = `scaleX(${cappedScrollPercentage})`;
  });
}

function initScrollProgress(image) {
  const scrollContainers = document.querySelectorAll(
    ".mila--scoll-images[scroll-grid]"
  );

  if (!scrollContainers.length) return;

  scrollContainers.forEach((container) => {
    const scrollContainer = container.querySelector(".grid-product__images");
    const images = container.querySelectorAll(".grid-product__image img");
    const progressBar = container.querySelector(".progress-bar");

    calculateScrollProgress(scrollContainer, progressBar, images, 0.2, image);
  });
}

function giftWrap(root = document) {
  const wrap = root.querySelector(".gift_wrap_label");
  const prop = wrap?.querySelector(".GiftProp");

  if (!wrap || !prop) {
    console.warn("Required elements not found for gift wrap feature.");
    return;
  }

  const input = wrap.querySelector("#gift_wrap");

  input?.addEventListener("change", () => {
    prop.value = input.checked ? "yes" : "";
  });
}

function drawerMegaImages() {
  let drawer = document.getElementById("NavDrawer");
  let imageContainer = document.getElementById("DrawerMegaMenuImages");

  if (!drawer || !imageContainer) return;

  let images = drawer.querySelectorAll(".mobile-nav .megamenu__promo");

  images.forEach((image) => imageContainer.appendChild(image));
}

function scrollToAnchorWithOffset(id, offset = 80) {
  const element = document.getElementById(id);
  if (element) {
    const elementPosition =
      element.getBoundingClientRect().top + window.pageYOffset;
    const offsetPosition = elementPosition - offset;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    });
  } else {
    console.error(`Element with ID "${id}" not found.`);
  }
}

function faqScroll() {
  let faqs = document.querySelectorAll(".faq--category li");

  if (!faqs.length) return;

  faqs.forEach((faq) => {
    faq.addEventListener("click", function (e) {
      e.preventDefault();
      let to = faq.dataset.scroll;
      if (!to) return;
      if (window.matchMedia("(max-width: 1024px)").matches) {
        scrollToAnchorWithOffset(to, 200);
      } else {
        scrollToAnchorWithOffset(to, 100);
      }
    });
  });
}

const loadAfterTheme = () => {
  showToolbar();
  giftWrap();
  switchImages();
  initScrollProgress();
  setupCollectionForm();
  drawerMegaImages();
  faqScroll();
};

function reinitAfterAjax() {
  initScrollProgress();
  setupCollectionForm();
  theme.initQuickShop();
}

document.addEventListener('cart:recommendation:loaded', function(e){
  let drawer = document.querySelector('#CartDrawer .drawer__scrollable');
  if(!drawer) return;
  drawer.appendChild(e.detail);
  reinitAfterAjax();
});

document.addEventListener("recommendations:loaded", reinitAfterAjax);
document.addEventListener("collection:reloaded", reinitAfterAjax);


document.addEventListener('ajaxProduct:added', function(e) {
  let id = e.detail.product.product_id;
  const newProductUrl = '/recommendations/products?section_id=sections--16314140524609__header&product_id=' + id + '&limit=10';
  let cart_recommendation = document.querySelector('cart-product-recommendations');

  if(cart_recommendation) {
    cart_recommendation.setAttribute('data-url', newProductUrl);
    cart_recommendation.fetchProducts();
  }
}, { once: true });


document.addEventListener("DOMContentLoaded", loadAfterTheme);







;(function() {
  // Move timestamp into last profile cell of a single header
  function moveTimestampIntoProfile(header) {
    if (header.dataset.tsMoved) return;
    const ts   = header.querySelector('.jdgm-row-rating .jdgm-rev__timestamp');
    const prof = header.querySelectorAll('.jdgm-row-profile');
    if (!ts || prof.length === 0) return;
    prof[prof.length - 1].appendChild(ts);
    header.setAttribute('data-ts-moved', 'true');
  }

  // Process all unhandled headers on the page
  function moveTimestamps() {
    document
      .querySelectorAll('.jdgm-rev__header:not([data-ts-moved])')
      .forEach(moveTimestampIntoProfile);
  }

  // 1) Initial pass immediately
  moveTimestamps();

  // 2) Poll every 500ms (up to 5s) for late AJAX-injected headers
  let attempts = 0;
  const poller = setInterval(() => {
    moveTimestamps();
    if (++attempts >= 10) clearInterval(poller);
  }, 500);

  // 3) MutationObserver for anything that appears after
  new MutationObserver(muts => {
    muts.forEach(m => {
      m.addedNodes.forEach(node => {
        if (!(node instanceof Element)) return;
        if (node.matches('.jdgm-rev__header')) {
          moveTimestampIntoProfile(node);
        } else {
          node.querySelectorAll('.jdgm-rev__header')
              .forEach(moveTimestampIntoProfile);
        }
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
})();

document.addEventListener('DOMContentLoaded', () => {
  const observer = new MutationObserver((mutations, obs) => {
    // 1. Find the reviews container
    const reviewsContainer = document.querySelector('.jdgm-rev-widg__reviews');
    if (!reviewsContainer) return;  // keep observing until it appears

    // 2. For each profile row inside it, append the badge if not already added
    reviewsContainer.querySelectorAll('.jdgm-row-profile .jdgm-rev__author-wrapper').forEach(profile => {
      // Avoid duplicating the badge
      if (profile.querySelector('.kl_reviews__review__verified')) return;

      // 3. Create your badge element
      const badge = document.createElement('span');
      badge.className = 'kl_reviews__review__verified';
      badge.innerHTML = `
        <div><img src="https://cdn.shopify.com/s/files/1/0614/6978/6177/files/verify.png?v=1751024690" width='15px' height='auto'></div>
        <span>Verified buyer</span>
      `;
      // 4. Append it into the profile row
      profile.appendChild(badge);
    });

    // Once we've injected badges into at least one profile, we can stop observing
    if (reviewsContainer.querySelector('.kl_reviews__review__verified')) {
      obs.disconnect();
      console.log('✅ Verified badges added to jdgm-row-profile elements');
    }
  });

  // Observe the entire document for new nodes
  observer.observe(document.body, { childList: true, subtree: true });
});





document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('click', function(event) {
    const removeButton = event.target.closest('.cart__remove');
    if (!removeButton) return;

    event.preventDefault();
    const itemKey = removeButton.dataset.cartItemKey;
    if (!itemKey) {
      console.error('Remove button missing data-cart-item-key attribute.');
      return;
    }

    // build the updates payload
    const updates = {};
    updates[itemKey] = 0;

    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ updates })
    })
    .then(response => {
      if (!response.ok) {
        return response.json().then(err => {
          throw new Error(err.description || err.message || 'Unknown error.');
        });
      }
      return response.json();
    })
    .then(updatedCart => {
      console.log('Cart updated:', updatedCart);

      // Let any listeners know the cart data changed
      document.dispatchEvent(new CustomEvent('cart:updated', {
        detail: { cart: updatedCart }
      }));

      // *** Trigger your CartForm to re-build itself ***
      document.dispatchEvent(new CustomEvent('cart:build'));

      // (Optionally) remove the item from the DOM immediately
      const cartItemEl = removeButton.closest('.cart__item');
      if (cartItemEl) cartItemEl.remove();

      // And update any simple count/price elements you have
      const countEl = document.querySelector('.cart-count-bubble span');
      if (countEl) countEl.textContent = updatedCart.item_count;

      const totalEl = document.querySelector('.cart-total-price span');
      if (totalEl) {
        totalEl.textContent = `$${(updatedCart.total_price / 100).toFixed(2)}`;
      }
    })
    .catch(err => {
      console.error('Error updating cart:', err);
      alert(`Failed to update cart: ${err.message}`);
    });
  });
});
